import { makeStyles, Tab, Tabs, Typography } from '@material-ui/core';
import { enTypeComment } from 'interface/lessonComment';
import React, { useState } from 'react';
import Comments from './Comments';
import { CourseTheme } from 'assets/themes/Course';
import { IDataWithPagination, saveComment, fetchComments } from 'services/comments';
import MakeComments from './Comments/MakeComment';
import { useAppSelector } from 'hooks/redux';
import { sendElastic } from 'actionCreators/judasLog';
import { useParams } from 'react-router-dom';
import { hjTagging } from 'utils';
import { ICourse } from 'interface/course';

enum enTabs {
  'comments' = 0,
  'ownComments' = 1,
  'lessonFiles' = 2,
}

const useStyles = makeStyles<CourseTheme>((theme) => ({
  tabRootContainer: {
    minHeight: 500,
    maxHeight: 500,
    height: 500,
    overflow: 'hidden',
    marginBottom: theme.spacing(6),
  },
  tab: {
    fontWeight: 600,
    color: theme.variables.courseTheme.text,
    fontSize: 14,
    textTransform: 'inherit',
  },
  indicator: {
    background: theme.variables.courseTheme.divider,
  },
  root: {
    marginTop: theme.spacing(6),
  },
  title: {
    fontSize: 24,
    color: theme.variables.courseTheme.text,
    marginBottom: 30,
    fontWeight: 700,
  },
}));

const LessonTabs: React.FC = () => {
  const [tabIndex, setTabIndex] = useState<enTabs>(0);
  const [comments, setComments] = useState<Partial<IDataWithPagination>>({ data: [] });
  const [ownComments, setOwnComments] = useState<Partial<IDataWithPagination>>({ data: [] });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const lesson = useAppSelector((state) => state.newLesson.lesson);
  const course = useAppSelector((state) => state.course as ICourse);
  const params = useParams<{ courseHash: string }>();

  const classes = useStyles();

  const onSubmitComment = (lessonId: number, comment: string) => {
    setIsSubmitting(true);
    return saveComment(lessonId, comment)
      .then(() => {
        fetchComments({ type: enTypeComment.ownComment, lessonId })
          .then(setOwnComments)
          .then(() => {
            hjTagging('FEZ-COMENTARIO');
            sendElastic('commented', `Comentou na aula ${lesson.title}`, {
              courseHash: params.courseHash,
              lessonId: lesson.id,
            });
          });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const handleTabChange = (event: any, value: number) => {
    setTabIndex(value);
  };

  if (!lesson || lesson.disable_comments || !course || course.disable_comments || !isAuthenticated) {
    return null;
  }

  return (
    <div className={classes.root}>
      <Typography className={classes.title} id='lesson-comments'>
        Comentários
      </Typography>
      <MakeComments onSubmit={onSubmitComment} />
      <Tabs role='tablist' classes={{ indicator: classes.indicator }} value={tabIndex} onChange={handleTabChange}>
        <Tab role='tab' className={classes.tab} label='Todos os comentários' id='lesson-comments-all' />
        <Tab role='tab' className={classes.tab} label='Meus Comentários' id='lesson-comments-mine' />
      </Tabs>

      <div className={classes.tabRootContainer}>
        {tabIndex === enTabs.comments && (
          <div role='tabpanel' aria-labelledby='lesson-comments-all' aria-label='Aba de meus comentários'>
            <Comments comments={comments} setComments={setComments} type={enTypeComment.comments} />
          </div>
        )}
        {tabIndex === enTabs.ownComments && (
          <div role='tabpanel' aria-labelledby='lesson-comments-mine' aria-label='Aba de todos os comentários'>
            <Comments
              isSubmitting={isSubmitting}
              comments={ownComments}
              setComments={setOwnComments}
              type={enTypeComment.ownComment}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default LessonTabs;
